import { getTitleFromPageUrl } from '../../../utils/get-title-from-page-url';
import { createRemediationRule } from '../rule-factory/create-remediation-rule';

const PROCESSED_ATTR = 'data-uw-rm-title';
const PROCESSED_ATTR_VALUE = {
  UNKNOWN: 'un',
  GENERIC: 'gn',
};

const addProcessedAttr = (element: HTMLTitleElement, title: string): void => {
  element.setAttribute(
    PROCESSED_ATTR,
    title ? PROCESSED_ATTR_VALUE.GENERIC : PROCESSED_ATTR_VALUE.UNKNOWN,
  );
};

export const headerTitleRule = (): void => {
  /**
   * Title element should be only the one per document
   * this is why header title helper is helper that not based on list of updated elements
   * */
  const titleElement = document.getElementsByTagName('title')[0];

  try {
    const newTitle = getTitleFromPageUrl();

    if (!titleElement) {
      const newTitleElement = document.createElement('title');
      newTitleElement.innerHTML = newTitle;
      addProcessedAttr(newTitleElement, newTitle);
      document.head.appendChild(newTitleElement);
    } else if (
      !titleElement.innerHTML?.trim() &&
      !titleElement.hasAttribute(PROCESSED_ATTR)
    ) {
      titleElement.innerHTML = newTitle;
      addProcessedAttr(titleElement as HTMLTitleElement, newTitle);
    }
  } catch (err) {
    if (err instanceof Error) {
      console.error(err);
    }
  }
};

export const HeaderTitleRule = createRemediationRule({
  ruleId: 'header-title',
  rule: headerTitleRule,
});
